module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst additionalClasses = []\nconst fieldConfig = model.config || {}\nif(model.isDisabled)                additionalClasses.push('isDisabled');\nif(fieldConfig.isMultiline)         additionalClasses.push('multiline');\nif(fieldConfig.slimSwitch)          additionalClasses.push('slimSwitch');\nif(fieldConfig.singleButtonSwitch)  additionalClasses.push('singleButtonSwitch');\nif(config.bootstrapVersion)         additionalClasses.push('form-control');\n%><div data-field-type=\"toggle\" data-field-code=\"<%= model.fieldCode %>\" class=\"<%- additionalClasses.join(' ') %>\" data-selected-child-index=\"<%= model.selectedChildIndex %>\" style=\"--toggle-selected-child-index: <%= model.selectedChildIndex %>;\"><%\nif(fieldConfig.slimSwitch){\n%><div class=\"switch\"><div class=\"indicator\"></div></div><%\n}\n%><div class=\"options\"><%\nvar options = model.options;\nvar selectedChildIndex = model.selectedChildIndex;\nif(!!options){\nvar optionDisabled;\nvar optionName;\nvar optionDescription;\nvar optionValue;\nvar optionSelected;\nvar optionColor;\nvar aliases = model.aliases || {};\nvar alias;\nvar title;\nvar childConfig = model.childConfig || {};\nvar renderConfig = model.renderConfig || {};\nvar additionalStyle, additionalStyles;\nutils.forEach(options, function(child, childIndex){\noptionDisabled = false;\n// define option name\nif(!!child.lang && !!child.lang[storage.user.data.langCode] && !!child.lang[storage.user.data.langCode][childConfig.name]){\noptionName = child.lang[storage.user.data.langCode][childConfig.name];\n} else if (!!child[childConfig.name]) {\noptionName = child[childConfig.name];\n} else {\noptionName = '-NO-NAME-FOUND-';\n}\n// define option description\nif(!!child.lang && !!child.lang[storage.user.data.langCode] && !!child.lang[storage.user.data.langCode][childConfig.description]){\noptionDescription = child.lang[storage.user.data.langCode][childConfig.description];\n} else if (!!child[childConfig.description]) {\noptionDescription = child[childConfig.description];\n} else {\noptionDescription = '';\n}\n// define options' value\noptionValue = child[childConfig.value];\n// check if option is selected\nif(selectedChildIndex !== undefined){\noptionSelected = childIndex === selectedChildIndex;\n} else {\noptionSelected = optionValue === model.value;\n}\n// check for disabled values\noptionDisabled = (model.disabledValues || {})[optionValue] || false;\nadditionalStyle = '';\nadditionalStyles = [];\nif(child.color){\nif(optionSelected && (optionColor = ((model.colors || {})[optionValue] || {}).activeColor)){\nadditionalStyles.push('--toggle-bg-color: ' + optionColor);\n} else if((optionColor = ((model.colors || {})[optionValue] || {}).color)) {\nadditionalStyles.push('--toggle-bg-color: ' + optionColor);\n}\n}\nif(!optionSelected && (child.config || {}).fontColor){\nadditionalStyles.push('color: ' + child.config.fontColor);\n}\nelse if(optionSelected && (child.config || {}).complementaryColor){\nadditionalStyles.push('color: ' + child.config.complementaryColor);\n}\nif(additionalStyles.length > 0){\nadditionalStyle = ' style=\"' + additionalStyles.join(';') + '\"';\n}\nalias = aliases[optionValue] || {}\ntitle = optionName || ''\nif(alias.type !== 'symbol' && alias.name){\ntitle = alias.name\n}\nif(optionDescription){\ntitle = `${title} | ${optionDescription}`\n}\n%><div class=\"toggleOption<%= (optionSelected ? ' selected' : '') %><%= (optionDisabled ? ' disabled' : '') %>\" data-value=\"<%= optionValue %>\"<%- additionalStyle %> title=\"<%= title %>\"><%\nif(!fieldConfig.slimSwitch){\nif(alias.name){\nif(alias.type === 'symbol'){\n%><i class=\"<%= alias.name %>\" title=\"<%= title %>\"></i><%\n} else {\n%><%= alias.name %><%\n}\n} else if((child.config || {}).symbol) {\n%><i class=\"<%= child.config.symbol %>\" title=\"<%= title %>\"></i><%\n} else {\n%><%= optionName %><%\n}\n}\n%></div><%\n});\n%></div><%\n}\n%></div>"
  , __filename = "..\\..\\npm\\frontend-controller\\baseComponents\\form\\fields\\toggle.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const additionalClasses = []
const fieldConfig = model.config || {}
if(model.isDisabled)                additionalClasses.push('isDisabled');
if(fieldConfig.isMultiline)         additionalClasses.push('multiline');
if(fieldConfig.slimSwitch)          additionalClasses.push('slimSwitch');
if(fieldConfig.singleButtonSwitch)  additionalClasses.push('singleButtonSwitch');
if(config.bootstrapVersion)         additionalClasses.push('form-control');

    ; __line = 9
    ; __append("<div data-field-type=\"toggle\" data-field-code=\"")
    ; __append(escapeFn( model.fieldCode ))
    ; __append("\" class=\"")
    ; __append( additionalClasses.join(' ') )
    ; __append("\" data-selected-child-index=\"")
    ; __append(escapeFn( model.selectedChildIndex ))
    ; __append("\" style=\"--toggle-selected-child-index: ")
    ; __append(escapeFn( model.selectedChildIndex ))
    ; __append(";\">")
    ; 
if(fieldConfig.slimSwitch){

    ; __line = 11
    ; __append("<div class=\"switch\"><div class=\"indicator\"></div></div>")
    ; 
}

    ; __line = 13
    ; __append("<div class=\"options\">")
    ; 
var options = model.options;
var selectedChildIndex = model.selectedChildIndex;
if(!!options){
var optionDisabled;
var optionName;
var optionDescription;
var optionValue;
var optionSelected;
var optionColor;
var aliases = model.aliases || {};
var alias;
var title;
var childConfig = model.childConfig || {};
var renderConfig = model.renderConfig || {};
var additionalStyle, additionalStyles;
utils.forEach(options, function(child, childIndex){
optionDisabled = false;
// define option name
if(!!child.lang && !!child.lang[storage.user.data.langCode] && !!child.lang[storage.user.data.langCode][childConfig.name]){
optionName = child.lang[storage.user.data.langCode][childConfig.name];
} else if (!!child[childConfig.name]) {
optionName = child[childConfig.name];
} else {
optionName = '-NO-NAME-FOUND-';
}
// define option description
if(!!child.lang && !!child.lang[storage.user.data.langCode] && !!child.lang[storage.user.data.langCode][childConfig.description]){
optionDescription = child.lang[storage.user.data.langCode][childConfig.description];
} else if (!!child[childConfig.description]) {
optionDescription = child[childConfig.description];
} else {
optionDescription = '';
}
// define options' value
optionValue = child[childConfig.value];
// check if option is selected
if(selectedChildIndex !== undefined){
optionSelected = childIndex === selectedChildIndex;
} else {
optionSelected = optionValue === model.value;
}
// check for disabled values
optionDisabled = (model.disabledValues || {})[optionValue] || false;
additionalStyle = '';
additionalStyles = [];
if(child.color){
if(optionSelected && (optionColor = ((model.colors || {})[optionValue] || {}).activeColor)){
additionalStyles.push('--toggle-bg-color: ' + optionColor);
} else if((optionColor = ((model.colors || {})[optionValue] || {}).color)) {
additionalStyles.push('--toggle-bg-color: ' + optionColor);
}
}
if(!optionSelected && (child.config || {}).fontColor){
additionalStyles.push('color: ' + child.config.fontColor);
}
else if(optionSelected && (child.config || {}).complementaryColor){
additionalStyles.push('color: ' + child.config.complementaryColor);
}
if(additionalStyles.length > 0){
additionalStyle = ' style="' + additionalStyles.join(';') + '"';
}
alias = aliases[optionValue] || {}
title = optionName || ''
if(alias.type !== 'symbol' && alias.name){
title = alias.name
}
if(optionDescription){
title = `${title} | ${optionDescription}`
}

    ; __line = 83
    ; __append("<div class=\"toggleOption")
    ; __append(escapeFn( (optionSelected ? ' selected' : '') ))
    ; __append(escapeFn( (optionDisabled ? ' disabled' : '') ))
    ; __append("\" data-value=\"")
    ; __append(escapeFn( optionValue ))
    ; __append("\"")
    ; __append( additionalStyle )
    ; __append(" title=\"")
    ; __append(escapeFn( title ))
    ; __append("\">")
    ; 
if(!fieldConfig.slimSwitch){
if(alias.name){
if(alias.type === 'symbol'){

    ; __line = 87
    ; __append("<i class=\"")
    ; __append(escapeFn( alias.name ))
    ; __append("\" title=\"")
    ; __append(escapeFn( title ))
    ; __append("\"></i>")
    ; 
} else {

    ; __line = 89
    ; __append(escapeFn( alias.name ))
    ; 
}
} else if((child.config || {}).symbol) {

    ; __line = 92
    ; __append("<i class=\"")
    ; __append(escapeFn( child.config.symbol ))
    ; __append("\" title=\"")
    ; __append(escapeFn( title ))
    ; __append("\"></i>")
    ; 
} else {

    ; __line = 94
    ; __append(escapeFn( optionName ))
    ; 
}
}

    ; __line = 97
    ; __append("</div>")
    ; 
});

    ; __line = 99
    ; __append("</div>")
    ; 
}

    ; __line = 101
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\..\npm\frontend-controller\baseComponents\form\fields\toggle.ejs

}